import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import ThreeGroup from '../../groups/ThreeGroup';
import useToast from '../../../hooks/useToast';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../api/users';
import { setSelectUser } from '../../../store/apps/usersSlice';
import { useDispatch } from 'react-redux';
import { dispatchCusEvent } from '../../../utils';
import { ENUM_CUS_EVENT } from '../../../enums/enums';
import useGroupThree from '../../../hooks/site/useGroupThree';
import { useAppSelector } from '../../../store';

export default function TransferAccount({ open, closeModal, userIdList, setChosenList }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { successToast } = useToast();
  const { updateChildrenGroup } = useGroupThree();
  const mainGroupId = useAppSelector((state) => state.user.group.main?.groupId);

  const [selectGroupId, setSelectGroupId] = useState();

  const onSaveClick = () => {
    console.log('chosenList', userIdList);
    API_USERS.info.group
      .move({ userList: userIdList, groupId: selectGroupId })
      .then((e) => {
        setChosenList([]);
        dispatch(setSelectUser({}));
        dispatchCusEvent(ENUM_CUS_EVENT.handlerOnFindClick);
        successToast('Accounts have been successfully transferred');
        closeModal();
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!mainGroupId) return;
    setSelectGroupId(mainGroupId);
  }, [mainGroupId]);

  useEffect(() => {
    if (!selectGroupId) return;
    if (!open) return;

    updateChildrenGroup(selectGroupId);
  }, [selectGroupId, open]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={`${t('Transfer accounts')} ${userIdList.length} ?`}
      maxWidth="xs"
      saveText="transfer"
      onSaveClick={onSaveClick}>
      <ThreeGroup
        chooseGroupId={selectGroupId}
        setChooseGroupeId={setSelectGroupId}
        isManualUpdate
      />
    </InfoDialog>
  );
}
